import productViewDataLayer from "../autoload/gtm";
let filterCount = $(".filters-main__btn").attr("data-filters-count");
if (
  $(".tour-list")
    .children()
    .hasClass("no-posts")
) {
  $(".tour-list").css("display", "block");
}
$(".filters-main__btn").click(function () {
  if ($(".filters-tax").is(":visible")) {
    $(".filters-tax").hide();
  } else {
    $(".filters-tax").show();
  }
  $(".archive-wrapper").toggleClass("overflow-archive");
  $(".archive-wrapper__main-content").toggleClass("slide-content");
  $(".filters-main__btn").toggleClass("filter-click");
  if ($(this).hasClass("filter-click")) {
    $(this).text(translations.closeFilters);
  } else {
    $(this).text(translations.filters + " " + filterCount);
  }
  if ($(window).width() >= 1024) {
    $(".filters-main").toggleClass("max-width");
  }
});

$(".filters-tax__item>span").click(function () {
  $(this)
    .next(".filters-tax__terms")
    .slideToggle();
  $(this).toggleClass("slide-down");
});
/* eslint-disable */

// const queryString = window.location.search;
const urlParams = function (name) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
};
if (urlParams("startdate") !== null) {
  filterSubmit()
};
let durationCheckbox = $('.filters-tax__checkbox_duration');
function durationFilter() {
  durationCheckbox.each(function () {
    if ($(this).parent().parent().siblings().find('.filters-tax__checkbox_duration').is(':checked')) {
      $(this).click(function () {
        $(this).parent().parent().siblings().find('.filters-tax__checkbox_duration').prop('checked', false);
        filterSubmit()
      });
    }
  })
}
durationFilter();
function filterSubmit() {
  let filterData = $("#filters-tax").serialize();
  let filterDataArray = $("#filters-tax").serializeArray();
  let filterDataLength = filterDataArray.length - 3;
  let selectedSortDirection = $('.filters-main__date-option option:selected').attr('data-direction');

  filterCount = filterDataLength !== 0 ? "(" + filterDataLength + ")" : "";
  if (window.location.href.indexOf("page") > -1) {
    window.history.replaceState({}, document.title, "/tours/?" + filterData + "&sort-dir=" + selectedSortDirection);
  }
  window.history.replaceState({}, document.title, "?" + filterData + "&sort-dir=" + selectedSortDirection);
  $.ajax({
    type: "POST",
    url: themeVars.ajax_url,
    data: {
      action: "tourListLoad",
      data: filterData,
      sortDir: selectedSortDirection,
    },
    beforeSend: function () {
      $(".tour-list-preloader").show();
    },
    success: function (response) {
      $(".tour-list-preloader").hide();
      $(".tour-list-wrapper").html(response);
      if (
        $(".tour-list")
          .children()
          .hasClass("no-posts")
      ) {
        $(".tour-list").css("display", "block");
      }
      $("a.page-numbers").each(function () {
        let _href = $(this).attr("href");
        $(this).attr("href", _href + "?" + filterData);
      });
      durationFilter();

      //send GTM info
      productViewDataLayer($('.tour-list'), themeVars['title']);
    }
  });
}
$(".filters-main__day").click(function () {
  var sibling = $(this).siblings(".filters-main__day");
  var dayValue = $(this).val();
  if (sibling.hasClass("checked")) {
    sibling.removeClass("checked");
  }
  $(this).addClass("checked");
  $("input[name='filter-startdate']").val(dayValue);
  $("input[name='filter-enddate']").val(dayValue);
  $("#filters-tax").submit(filterSubmit());
});

$(".filters-main__date-option").change(function () {
  var dateValue = $(this).val();
  $('select[name="filter-sortby"]').val(dateValue);
  $("#filters-tax").submit(filterSubmit());
});
let sortBy = $(".filters-main__date-option>option");
for (var i = 0; i < sortBy.length; i++) {
  if ($(sortBy[i]).val() == urlParams("filter-sortby") && $(sortBy[i]).attr('data-direction') == urlParams("sort-dir")) {
    $(sortBy[i]).attr("selected", "selected");
  }
}
let daysValue = $(".filters-main__day");
for (var i = 0; i < daysValue.length; i++) {
  if ($(daysValue[i]).val() == urlParams("filter-startdate")) {
    $(daysValue[i]).addClass("checked");
    $("input[name='filter-startdate']").val($(daysValue[i]).val());
  }
  if (
    $(daysValue[i]).val() != urlParams("filter-startdate") ||
    urlParams("filter-enddate")
  ) {
    $(daysValue[i]).removeClass("checked");
  }
}
let sDate = $('input[name="filter-startdate"]');
let eDate = $('input[name="filter-enddate"]');

if (
  urlParams("filter-startdate") != "" &&
  urlParams("filter-startdate") != null &&
  (urlParams("filter-enddate") != "" && urlParams("filter-enddate") != null)
) {
  let startDate = new Date(urlParams("filter-startdate"));
  let endDate = new Date(urlParams("filter-enddate"));
  let startDay = urlParams("filter-startdate").slice(8);
  let endDay = urlParams("filter-enddate").slice(8);
  let startMonth = startDate.toLocaleString("default", {
    month: "long"
  });
  let endMonth = endDate.toLocaleString("default", {
    month: "long"
  });
  let newStartDateFormat = startMonth + " " + startDay;
  let newEndDateFormat = endMonth + " " + endDay;
  sDate.val(urlParams("filter-startdate"));
  eDate.val(urlParams("filter-enddate"));
  $(".filters-main__calendar-input").text(
    newStartDateFormat + " - " + newEndDateFormat
  );
  if (sDate.val() == eDate.val()) {
    $(".filters-main__calendar-input").text(newStartDateFormat);
    $(".filters-main__calendar").removeClass("filters-main__calendar_width");
  }
  if ($(window).width() <= 430) {
    $(".filters-main__calendar").addClass("dates-on-mobile");
  }
  if ($(window).width() >= 720 && $(window).width() < 992) {
    $(".filters-main__calendar").addClass("filters-main__calendar_width");
  }
}
$(window).resize(function () {
  if (
    $(window).width() <= 430 &&
    !$(".filters-main__calendar").hasClass("dates-on-mobile")
  ) {
    $(".filters-main__calendar").addClass("dates-on-mobile");
  }
});
$(".filters-tax__checkbox").click(function () {
  $("#filters-tax").submit(filterSubmit());
});
$(".filters-tax__clean").click(function () {
  if (window.location.search != 0) {
    window.location.search = "";
    $(".filters-main__calendar").removeClass("filters-main__calendar_width");
  }
});
$(".filters-main__calendar").datepicker({
  range: "period",
  dateFormat: "yy-mm-dd",
  firstDay: 1,
  dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
  showOtherMonths: true,
  selectOtherMonths: true,
  prevText: "",
  nextText: "",
  onSelect: function (dateText, inst, extensionRange) {
    $(".filters-main__startdate").val(extensionRange.startDateText);
    $(".filters-main__enddate").val(extensionRange.endDateText);
    let startDate = new Date(extensionRange.startDateText);
    let endDate = new Date(extensionRange.endDateText);
    let startDay = extensionRange.startDateText.slice(8);
    let endDay = extensionRange.endDateText.slice(8);
    let startMonth = startDate.toLocaleString("default", {
      month: "long"
    });
    let endMonth = endDate.toLocaleString("default", {
      month: "long"
    });
    let newStartDateFormat = startMonth + " " + startDay;
    let newEndDateFormat = endMonth + " " + endDay;

    if (extensionRange.startDateText !== extensionRange.endDateText) {
      $(".filters-main__calendar-input").text(
        newStartDateFormat + " - " + newEndDateFormat
      );
    } else {
      $(".filters-main__calendar-input").text(newStartDateFormat);
    }
  }
});
$("html").click(function (e) {
  if (
    $(e.target).hasClass("filters-main__calendar") ||
    $(e.target).hasClass("filters-main__calendar-input")
  ) {
    $(daysValue).removeClass("checked");
    $(".filters-main__calendar > .ui-datepicker-inline").toggle();
    $(".filters-main__calendar").addClass("active");
    $(".filters-main__calendar-button").toggle();
  } else {
    if (!$(e.target).hasClass("ui-corner-all")) {
      $(".filters-main__calendar > .ui-datepicker-inline").hide();
      $(".filters-main__calendar").removeClass("active");
      $(".filters-main__calendar-button").hide();
    }
  }
});
$(".filters-main__calendar-button > span.apply").click(function () {
  $("#filters-tax").submit(filterSubmit());
});

$(".filters-main__calendar-button > span.clear").click(function () {
  $(".filters-main__startdate").val('');
  $(".filters-main__enddate").val('');
  $(".filters-main__calendar").datepicker('setDate', null);
  // $('.selected-start').removeClass('selected-start');
  // $('.selected-end').removeClass('selected-end');
  // $('.ui-state-active').removeClass('ui-state-active');
  // $('.selected').removeClass('selected');
  $(".filters-main__calendar-input").html('Date');
  $("#filters-tax").submit(filterSubmit());
});


$(".filters-main__calendar > .ui-datepicker-inline").hide();

$(function () {
  if ((urlParams("filter-startdate") != null || 0) ||
    $(".filters-main__day").hasClass("checked")
  ) {
    $("html, body").animate(
      { scrollTop: $("#tour-title").offset().top - 20 },
      1000
    );
  }
});

$(window).resize(function () {
  if (
    $(window).width() >= 1024 &&
    $(".filters-tax").css("display") == "block"
  ) {
    $(".filters-main").addClass("max-width");
  }
});
if (urlParams("filter-startdate") == $('.filters-main__today').val() && urlParams("filter-enddate") == $('.filters-main__today').val()) {
  $('.filters-main__today').addClass('active')
}



// WEBPACK FOOTER //
// ./scripts/modules/filter.js